<script setup>
import { computed } from 'vue'
import { Field } from 'vee-validate'
import visa from '@static/svg/brands/visa.svg'
import mastercard from '@static/svg/brands/mastercard.svg'
import amex from '@static/svg/brands/amex.svg'
import discover from '@static/svg/brands/discover.svg'
import applePay from '@static/svg/brands/apple_pay.svg'
import googlePay from '@static/svg/brands/google_pay.svg'
import link from '@static/svg/brands/link.svg'

const props = defineProps({
  paymentMethods: {
    type: Array,
    required: true,
    default: () => []
  },
  name: {
    type: String,
    required: true,
    default: 'payment_method'
  },
  rules: {
    type: Object,
    required: false,
    default: () => ({})
  }
})

const getCardImage = (brand) => {
  const brandMap = {
    visa,
    mastercard,
    amex,
    discover,
    apple_pay: applePay,
    google_pay: googlePay,
    link
  }

  const normalizedBrand = brand.toLowerCase()
  return brandMap[normalizedBrand] || ''
}
</script>

<template>
  <!-- List Group -->
  <ul class="list-unstyled mb-5">
    <li v-for="method in paymentMethods" :key="method.id" class="mb-2">
      <label
        class="form-control d-flex align-items-center"
        :for="name + method.id"
      >
        <span class="form-check">
          <Field
            :id="name + method.id"
            :name="name"
            type="radio"
            :value="method.id"
            :rules="rules"
            class="form-check-input"
          />
        </span>

        <div class="ms-3 flex-grow-1">
          <div class="mb-2">
            <h5 class="mb-0">
              {{ method.billingDisplayName }}
              <span v-if="method.isDefault" class="badge bg-primary ms-1"
                >Default</span
              >
              <span v-if="method.isExpired" class="text-danger small ms-1"
                >Expired</span
              >
            </h5>
          </div>

          <!-- Payment Method Details -->
          <div class="d-flex">
            <div class="flex-shrink-0">
              <img
                v-if="method.wallet"
                class="avatar avatar-xs"
                :src="getCardImage(method.wallet)"
                :alt="method.wallet"
              />
              <img
                class="avatar avatar-sm"
                :src="getCardImage(method.brand)"
                :alt="method.brand"
              />
            </div>

            <div class="flex-grow-1 ms-3">
              <div class="row">
                <div class="col-sm mb-3 mb-sm-0">
                  <span class="d-block text-dark">{{
                    method.displayName
                  }}</span>
                  <small class="d-block text-muted">
                    Expires {{ method.expiryDisplay }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </label>
    </li>
  </ul>
</template>
